function test () {
  console.log('you import me');
}
function deepClone(obj){
  if(typeof obj !== 'object' || typeof obj == null ){
    return obj;
  }
  let result = {};
  if(obj instanceof Array){
    result = [];
  }
  for( let key in obj){
    if(obj.hasOwnProperty(key)){
      result[key] = deepClone(obj[key]);
    }
  }
  return result;
}

export {
  test,
  deepClone
}
